import React, { useEffect, useState } from "react";
import { dbURL } from "./global";
import { convertDateToAgo } from "./functions";

async function getHistory(id) {
  const address = dbURL + "getHistory.php";
  const options = {
    method: "POST",
    mode: "cors",
    credentials: "include",
    body: JSON.stringify({
      id: parseInt(id),
    }),
  };
  const response = await fetch(address, options);
  const result = await response.json();

  return result;
}

function History(props) {
  const { ID } = props.itemData;
  const { tabItems } = props;
  const [history, setHistory] = useState();

  useEffect(() => {
    getHistory(ID).then((items) => {
      const sortedHistory = items.sort(
        (a, b) => parseInt(b["ID"]) - parseInt(a["ID"])
      );
      setHistory([{ ...props.itemData }, ...sortedHistory]);
    });
  }, []);

  return (
    <div>
      <div className="historyList">
        <div className="historyHead">
          {tabItems.map((item, index) => (
            <div key={index}>{tabItems[index].textLong}</div>
          ))}
        </div>
        <div className="historyItems">
          {history && history.length !== 0
            ? history.map((item, index) => (
                <div
                  className={(index === 0 ? "current " : "") + "historyItem"}
                  key={index}
                >
                  {tabItems.map((tab, ind) => {
                    /*     if (tab.dataItem === "DateDone")
                      return (
                        <div title={item["DateDone"]}>
                          {convertDateToAgo(item["DateDone"])}
                        </div>
                      );*/
                    let previous, current;
                    if (index < history.length && history[index + 1]) {
                      previous = history[index + 1][tab["dataItem"]];
                      current = item[tab["dataItem"]];
                    }

                    //console.log(index,ind,tabItems,item,tab)
                    return (
                      <div key={ind}>
                        <div
                          className={
                            current !== previous 
                              ? "newHistory"
                              : ""
                          }
                        >
                          {current !== previous || index === 0
                            ? current
                            : ""}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))
            : "Wpis nie był jeszcze edytowany."}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div className="historyList">
        {history && history.length !== 0
          ? history.map((item, index) => (
              <div
                className={(index === 0 ? "current " : "") + "historyItem"}
                key={index}
              >
                <div>{index}</div>
                <div title={item["DateDone"]}>
                  {convertDateToAgo(item["DateDone"])}
                </div>
                <div>{item["CreatedByUser"]}</div>
                <div>{item["ModifiedByUser"]}</div>
                <div>{item["EmployeeInvolded"]}</div>
                <div>{item["Description"]}</div>
                <div>{item["ApprovedSolution"]}</div>
              </div>
            ))
          : "Wpis nie był jeszcze edytowany."}
      </div>
    </div>
  );
}
/*
ApprovedSolution: "Defeats Harkonnen & Sardaukar";
CreatedByUser: "michalw";
DateDone: "2021-11-19 13:37:34";
DateReportedByManager: "2021-11-17";
Deleted: "0";
Description: "Theres a problem.";
DocNumber: "324234";
DocType: "0";
EmployeeInvolved: "Justyna Szymańska";
ID: "296";
ProblemOrError: "1";
Resolved: "1";*/

export default History;
